var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dicta-tools"},[_c('div',{staticClass:"description d-flex justify-content-center text-center text-white align-items-center"},[_c('h1',[_vm._v(_vm._s(_vm.hebrew ? 'הכלים שלנו ' : 'Dicta\'s Tools'))])]),_c('Tools')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }